import { render, staticRenderFns } from "./SpecialStudies.vue?vue&type=template&id=60cd68c4&scoped=true&"
import script from "./SpecialStudies.vue?vue&type=script&lang=js&"
export * from "./SpecialStudies.vue?vue&type=script&lang=js&"
import style0 from "./SpecialStudies.vue?vue&type=style&index=0&id=60cd68c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cd68c4",
  null
  
)

export default component.exports